/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

import {
  MEETINGS
} from '../constants';

/**
 * @class InMeetingActions
 */
export default class InMeetingActions {
  namespace = MEETINGS;

  constructor() {
    this.canLock = null;
    this.canUnlock = null;
    this.canAssignHost = null;
  }

  setCanLock(lock) {
    this.canLock = lock;
  }

  setCanUnlock(unlock) {
    this.canUnlock = unlock;
  }

  setCanAssignHost(host) {
    this.canAssignHost = host;
  }

  getCanLock() {
    return this.canLock;
  }

  getCanUnlock() {
    return this.canUnlock;
  }

  getCanAssignHost() {
    return this.canAssignHost;
  }
}

